export default "__VITE_ASSET__CmQzPCtT__"